/**
 * Convert relative image paths to absolute URLs based on API configuration
 * Supports environment variables for flexibility across dev/staging/production
 * Also handles old URLs with port 5000 by extracting the path and using current backend URL
 */
export const getImageUrl = (imageUrl) => {
  if (!imageUrl) {
    return 'https://via.placeholder.com/300x200?text=No+Image';
  }
  
  // If it's already an absolute URL
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    // Extract the image path from old URLs (e.g., localhost:5000/uploads/images/xxx.jpg)
    // Match patterns like http://localhost:5000/uploads/... or http://localhost:4000/uploads/...
    const pathMatch = imageUrl.match(/\/uploads\/.+/);
    if (pathMatch) {
      const imagePath = pathMatch[0];
      // Get current backend URL
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
      const backendUrl = process.env.REACT_APP_BACKEND_URL || apiUrl.replace('/api', '');
      return `${backendUrl}${imagePath}`;
    }
    // Return as-is if it doesn't match our pattern
    return imageUrl;
  }
  
  // If it's a relative path (starts with /), prepend the backend URL
  if (imageUrl.startsWith('/')) {
    // Get backend URL from environment or API URL
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
    const backendUrl = process.env.REACT_APP_BACKEND_URL || apiUrl.replace('/api', '');
    return `${backendUrl}${imageUrl}`;
  }
  
  return imageUrl;
};

export default getImageUrl;

